import React from 'react';

const contact = () => {
    return (
        <svg aria-hidden="true" focusable="false" role="presentation" className="icon icon-user" viewBox="0 0 64 64"><path fill = "transparent" d="M35 39.84v-2.53c3.3-1.91 6-6.66 6-11.41 0-7.63 0-13.82-9-13.82s-9 6.19-9 13.82c0 4.75 2.7 9.51 6 11.41v2.53c-10.18.85-18 6-18 12.16h42c0-6.19-7.82-11.31-18-12.16z"></path></svg>
    );  
}

export default contact;
